import MetricBase from "models/metrics/MetricBase";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import i18n from "i18next";
import ConnectivityGroup from "../../../../groups/ConnectivityGroup";

class MetricLivePricingTechnicalIssueCount extends MetricBase {
    constructor() {
        super({
            field: "metric_livePricingTechnicalIssueCount",
            defaultVisibility: true,
            unit: new EmptyUnit(),
            chartName: i18n.t("metrics.google_hotel_ads.livePricingTechnicalIssueCount.chartName"),
            serieLabel: i18n.t("metrics.google_hotel_ads.livePricingTechnicalIssueCount.serieLabel"),
            tooltip: i18n.t("metrics.google_hotel_ads.livePricingTechnicalIssueCount.tooltip"),
            group: new ConnectivityGroup(),
        });
    }
}

export default MetricLivePricingTechnicalIssueCount;
